import { withInstall } from '@element-plus/utils/with-install'

import Backtop from './src/backtop.vue'

export const ElBacktop = withInstall(Backtop)
export default ElBacktop

export * from './src/backtop'
